var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "footer",
    { staticClass: "the-footer flex-wrap justify-between", class: _vm.classes },
    [
      _c("p", [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.props.footer) } }),
        _vm._v(" Estas trabajando en el ambiente de "),
        _c(
          "strong",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "V." + _vm.props.version,
                expression: "'V.'+props.version"
              }
            ],
            staticClass: "text-danger"
          },
          [_vm._v(_vm._s(_vm.props.ambiente.replace("cion", "ción")))]
        )
      ]),
      _c(
        "span",
        { staticClass: "md:flex hidden items-center" },
        [
          _c("span", [_vm._v("Fabricado con amor")]),
          _c("feather-icon", {
            staticClass: "ml-2",
            attrs: {
              icon: "HeartIcon",
              svgClasses: "stroke-current text-danger w-6 h-6"
            }
          }),
          _c("span", { staticClass: "ml-3" }, [
            _vm._v("Ambiente de "),
            _c("strong", [
              _vm._v(_vm._s(_vm.props.ambiente.replace("cion", "ción")))
            ]),
            _c("span", { staticStyle: { "font-size": "70%" } }, [
              _vm._v("v." + _vm._s(_vm.props.version))
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }